if (!customElements.get('timeline-block-review')) {
  customElements.define(
    'timeline-block-review',
    class TimelineBlockReview extends HTMLElement {
      connectedCallback() {
        this.textEl = this.querySelector('[data-review-text]');
        this.toggleBtn = this.querySelector('[data-review-toggle]');

        if (!this.textEl || !this.toggleBtn) return;

        this.readMoreLabel = this.dataset.readMore ?? '';
        this.showLessLabel = this.dataset.showLess ?? '';

        this.onToggle = this.onToggle.bind(this);
        this.updateOverflow = this.updateOverflow.bind(this);

        this.toggleBtn.addEventListener('click', this.onToggle);

        this.resizeObserver = new ResizeObserver(this.updateOverflow);
        this.resizeObserver.observe(this.textEl);

        if (document.fonts?.ready) {
          document.fonts.ready.then(this.updateOverflow);
        }

        this.updateOverflow();
      }

      disconnectedCallback() {
        this.toggleBtn?.removeEventListener('click', this.onToggle);
        this.resizeObserver?.disconnect();
      }

      onToggle() {
        const expanded = this.textEl.classList.toggle('is-expanded');
        this.toggleBtn.textContent = expanded
          ? this.showLessLabel
          : this.readMoreLabel;
        this.toggleBtn.setAttribute('aria-expanded', String(expanded));
      }

      updateOverflow() {
        if (this.textEl.classList.contains('is-expanded')) return;

        const overflowing =
          this.textEl.scrollHeight - this.textEl.clientHeight > 2;
        this.toggleBtn.hidden = !overflowing;
      }
    },
  );
}
